<script setup lang="ts">
import UiIcon, { type UiIconProps } from './UiIcon.vue';
import UiNavLink from './UiNavLink.vue';
import UiText from './UiText.vue';

interface UiBackButtonProps {
    href?: string;
    target?: string;
    rel?: string;
    label?: string;
    icon?: UiIconProps['name'];
    description?: string;
}

const props = withDefaults(defineProps<UiBackButtonProps>(), {
    href: '',
    target: '',
    rel: '',
    label: 'Back',
    icon: 'arrow-narrow-left',
    description: '',
});
</script>

<template>
    <UiNavLink :href="props.href" :target="props.target" :rel="props.rel" class="flex flex-col gap-1">
        <div class="flex items-center gap-1">
            <UiIcon :name="props.icon" class="w-5 h-5" />
            <UiText :text="props.label" as="span" variant="h6" class="font-semibold" />
        </div>
        <UiText :text="props.description" as="span" variant="caption-normal" class="text-gray-500" />
    </UiNavLink>
</template>
